import { render, staticRenderFns } from "./login-overseas.vue?vue&type=template&id=56de9be3&scoped=true"
import script from "./login-overseas.vue?vue&type=script&lang=js"
export * from "./login-overseas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de9be3",
  null
  
)

export default component.exports